import { useCallback } from 'react';

import { useCookieConsents } from '../../../modules/cookie-consents/CookieConsentsProvider';

export const useRegisterTelemetryEvent = () => {
  const {
    consents: { analytics: analyticsConsent, marketing: marketingConsent },
  } = useCookieConsents();

  const register = useCallback(
    (event: Record<string, any>) => {
      if (!analyticsConsent && !marketingConsent) {
        return;
      }

      if (typeof window === 'undefined') {
        return;
      }

      if (!window.dataLayer) {
        window.dataLayer = [];
      }

      window.dataLayer.push(event);
    },
    [analyticsConsent, marketingConsent],
  );

  return register;
};
